<template>
    <v-row no-gutters>
        <v-container class="mt-3">
            <template>
                <v-row justify="center">
                    <v-dialog v-model="dialog" persistent max-width="400">
                        <v-progress-linear v-if="isLoading" indeterminate color="indigo darken-2"></v-progress-linear>
                        <v-card>
                            <v-card-title class="text-h5">
                                Konfirmasi
                            </v-card-title>
                            <v-card-text style="min-height: 50px;">Apakah anda yakin isian anda sudah benar?</v-card-text>
                            <v-card-actions class="justify-content-center">
                                <v-spacer></v-spacer>
                                <v-btn :disabled="isLoading" color="indigo darken-4" text @click="onCloseDialog(false)">
                                    Batal
                                </v-btn>
                                <v-btn :disabled="isLoading" color="indigo darken-4 white--text"
                                    @click="onCloseDialog(true)">
                                    Simpan
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-card class="p-4">
                    <v-form ref="register" v-model="register" lazy-validation>
                        <h6 class="text-body-1 pb-5 indigo--text text--darken-4">Buat Surat {{ kode_surat == 'SPP' ?
                            'Permohonan Ke Perusahaan' : 'Surat Tugas' }}<v-icon
                                class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                        <v-row>
                            <v-col cols="12" sm="12" md="6">
                                <v-menu ref="datePicker3" v-model="datePicker3" :close-on-content-click="false"
                                    :return-value.sync="formLetter.tanggal_surat" transition="scale-transition" offset-y
                                    min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field filled background-color="gray" v-model="format_tanggal_surat"
                                            :rules="$rules.required" append-icon="mdi-calendar" readonly v-bind="attrs"
                                            v-on="on">
                                            <template #label>
                                                Tanggal surat<span class="red--text"><strong>*
                                                    </strong></span>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="formLetter.tanggal_surat" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="datePicker3 = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary"
                                            @click="$refs.datePicker3.save(formLetter.tanggal_surat)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row v-if="kode_surat == 'SPP'">
                            <v-col cols="12" sm="12" md="6">
                                <v-menu ref="datePicker1" v-model="datePicker1" :close-on-content-click="false"
                                    :return-value.sync="formLetter.tanggal_realisasi_mulai_kp" transition="scale-transition"
                                    offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field filled background-color="gray"
                                            v-model="format_tanggal_realisasi_mulai_kp" :rules="$rules.required"
                                            append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                                            <template #label>
                                                Rencana mulai KP<span class="red--text"><strong>*
                                                    </strong></span>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="formLetter.tanggal_realisasi_mulai_kp" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="datePicker1 = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary"
                                            @click="$refs.datePicker1.save(formLetter.tanggal_realisasi_mulai_kp)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-menu ref="datePicker2" v-model="datePicker2" :close-on-content-click="false"
                                    :return-value.sync="formLetter.tanggal_realisasi_selesai_kp"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field filled background-color="gray"
                                            v-model="format_tanggal_realisasi_selesai_kp" :rules="$rules.required"
                                            append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                                            <template #label>
                                                Rencana selesai KP<span class="red--text"><strong>*
                                                    </strong></span>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="formLetter.tanggal_realisasi_selesai_kp" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="datePicker2 = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary"
                                            @click="$refs.datePicker2.save(formLetter.tanggal_realisasi_selesai_kp)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field filled background-color="gray" v-model="formLetter.nama_perusahaan"
                                    :rules="$rules.required" required>
                                    <template #label>
                                        Nama perusahaan<span class="red--text"><strong>* </strong></span>
                                    </template></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-textarea filled background-color="gray" v-model="formLetter.alamat_perusahaan"
                                    :rules="$rules.required" label="Alamat perusahaan">
                                    <template #label>
                                        Alamat perusahaan<span class="red--text"><strong>* </strong></span>
                                    </template></v-textarea>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete v-model="mahasiswa" return-object :items="listStudent" filled chips
                                    color="blue-grey lighten-2" :rules="$rules.array_required" label="Pilih mahasiswa"
                                    placeholder="Tambah mahasiswa" item-text="name" item-value="id" multiple>
                                    <template v-slot:selection="data">
                                        {{ data.item.name + ', ' }}
                                    </template>
                                </v-autocomplete>
                                <v-row v-if="mahasiswa.length > 0">
                                    <v-simple-table>
                                        <template>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        No.
                                                    </th>
                                                    <th class="text-left">
                                                        Nama
                                                    </th>
                                                    <th class="text-left">
                                                        NIM
                                                    </th>
                                                    <th class="text-left">
                                                        Aksi
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in mahasiswa" :key="item.name">
                                                    <td color="indigo--text text--darken-4">{{ index + 1 }}</td>
                                                    <td>{{ item.name }}</td>
                                                    <td>{{ item.no_induk }}</td>
                                                    <td><v-icon color="dark" class="mr-2" @click="onDeleteItem(item)">
                                                            mdi-delete
                                                        </v-icon></td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-row>
                            </v-col>
                        </v-row>
                        <div class="d-flex justify-content-center mt-5">
                            <v-btn outlined class="m-2" color="primary" @click="buttonBackClick()">
                                Kembali
                            </v-btn>
                            <v-btn class="m-2" color="primary" @click="dialog = true">
                                Simpan
                            </v-btn>
                        </div>
                    </v-form>
                </v-card>
            </template>
        </v-container>
    </v-row>
</template>

<script>
import { serialize } from "object-to-formdata";
export default {
    data() {
        return {
            formLetter: {
                tanggal_surat: undefined,
                nama_perusahaan: undefined,
                alamat_perusahaan: undefined,
                tanggal_realisasi_mulai_kp: null,
                tanggal_realisasi_selesai_kp: null,
            },
            mahasiswa: [],
            register: true,
            datePicker1: false,
            datePicker2: false,
            datePicker3: false,
            listStudent: [],
            dialog: false,
            isLoading: false,



        }
    }, created() {
        this.getListStudent();
        if (this.$route.query.update) this.FORM_STATUS = 'update';
        if (this.$route.query.kode_surat) this.kode_surat = this.$route.query.kode_surat;
    },
    computed: {
        format_tanggal_surat() {
            return this.formatDate(this.formLetter.tanggal_surat);
        },
        format_tanggal_realisasi_mulai_kp() {
            return this.formatDate(this.formLetter.tanggal_realisasi_mulai_kp);
        },
        format_tanggal_realisasi_selesai_kp() {
            return this.formatDate(this.formLetter.tanggal_realisasi_selesai_kp);
        }
    },
    watch: {
    },
    methods: {
        getListStudent() {
            const params = {
                status: 'kp',
            };
            this.isLoading = true;
            this.axios.get("/api/rekap/mahasiswa", { params: params }).then((res) => {
                this.listStudent = res.data.data.map(val => {
                    return {
                        id: val.id,
                        name: val.name,
                        no_induk: val.no_induk
                    }
                })
            }).finally(() => this.isLoading = false);
        },
        formatDate(date) {
            if (!date) return null

            const dates = new Date(date).toLocaleDateString('id-ID', { month: 'long', year: 'numeric', day: 'numeric' });
            return dates;
        },
        onDeleteItem(row) {
            let editedIndex = this.mahasiswa.indexOf(row)
            this.mahasiswa.splice(editedIndex, 1)
        },
        buttonBackClick() {
            this.$router.push({ name: "manage-letter.index" });
        },
        onCloseDialog(event) {
            if (event == true) {
                this.submit();
                this.dialog = false
            } else {
                this.dialog = false;
            }
        },
        submit() {
            console.log('tes');
            let url = "/api/surat/" + this.kode_surat;
            const valid = this.$refs.register.validate();
            if (valid) {
                this.isLoading = true;
                const options = {
                    indices: false,
                    nullsAsUndefineds: true,
                    booleansAsIntegers: false,
                    allowEmptyArrays: false,
                    noFilesWithArrayNotation: false,
                    dotsForObjectNotation: false,
                };
                if (this.FORM_STATUS === "update") {
                    this.formLetter["_method"] = "put";
                    url = "/api/surat/" + this.kode_surat;;
                }
                let formData = new FormData();
                formData = serialize(this.formLetter, options);
                console.log(this.mahasiswa);
                if (this.mahasiswa.length > 0) {
                    this.mahasiswa.forEach(val => {
                        formData.append('mahasiswa[][id]', val.id)
                    });
                }
                this.axios
                    .post(url, formData)
                    .then((res) => {
                        this.$emit("toast", "success", "Berhasil menyimpan data");
                        this.$router.push({ name: "manage-letter.index" });
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },
    }
}
</script>